<template>
  <div class="promotion-rank">
    <!-- 顶部活动横幅 -->
    <div class="header-banner">
      <div class="banner-decor">
        <span class="dot dot-1"></span>
        <span class="dot dot-2"></span>
        <span class="dot dot-3"></span>
        <span class="star star-1">&#9733;</span>
        <span class="star star-2">&#9733;</span>
        <span class="star star-3">&#9733;</span>
      </div>
      <div class="banner-crown crown-bounce" v-if="top3[0]">&#128081;</div>
      <div class="banner-title">推广英雄榜</div>
      <div class="banner-subtitle">有奖推广，推得多赚得多</div>
      <div class="banner-rule" @click="showRule = true">
        <van-icon name="info-o" size="12" /> 活动规则
      </div>
    </div>

    <!-- 加载状态 -->
    <div v-if="loading" class="loading-wrap">
      <van-loading type="spinner" color="#ff6034" size="36px" />
      <span class="loading-text">正在加载排名数据...</span>
    </div>

    <!-- 空状态 -->
    <van-empty v-else-if="!rankList.length" description="暂无排名数据" />

    <!-- 排名内容 -->
    <div v-else class="rank-content">
      <!-- 前三名领奖台 -->
      <div class="top3-podium">
        <!-- 第二名（左） -->
        <div class="podium-col second podium-enter" style="animation-delay: 0.1s" v-if="top3[1]">
          <div class="podium-card">
            <div class="podium-badge">
              <span class="badge-icon badge-bounce" style="animation-delay: 0.6s">&#129352;</span>
            </div>
            <div class="podium-ring silver-ring">
              <van-image v-if="top3[1].avatarUrl" round width="100%" height="100%" fit="cover" :src="top3[1].avatarUrl" />
              <div v-else class="avatar-fallback">{{ top3[1].promoterName.charAt(0) }}</div>
            </div>
            <div class="podium-name">{{ top3[1].promoterName }}</div>
            <div class="podium-stats">
              <span class="stat-num stat-pop" style="animation-delay: 0.8s">{{ top3[1].validPromotionCount }}</span>
              <span class="stat-label">有效推广</span>
            </div>
            <van-tag v-if="top3[1].qualified" color="#07c160" round size="medium" class="podium-tag">已达标</van-tag>
            <van-tag v-else plain color="#ff976a" round size="medium" class="podium-tag">未达标</van-tag>
          </div>
          <div class="podium-base silver-base">
            <span class="base-rank">2</span>
          </div>
        </div>
        <!-- 第一名（中） -->
        <div class="podium-col first podium-enter" style="animation-delay: 0.3s" v-if="top3[0]">
          <div class="sparkles">
            <span class="sparkle s1">&#10022;</span>
            <span class="sparkle s2">&#10022;</span>
            <span class="sparkle s3">&#10022;</span>
          </div>
          <div class="podium-card">
            <div class="podium-badge">
              <span class="badge-icon badge-bounce" style="animation-delay: 0.8s">&#129351;</span>
            </div>
            <div class="podium-ring gold-ring">
              <van-image v-if="top3[0].avatarUrl" round width="100%" height="100%" fit="cover" :src="top3[0].avatarUrl" />
              <div v-else class="avatar-fallback">{{ top3[0].promoterName.charAt(0) }}</div>
            </div>
            <div class="podium-name">{{ top3[0].promoterName }}</div>
            <div class="podium-stats">
              <span class="stat-num stat-pop" style="animation-delay: 1.0s">{{ top3[0].validPromotionCount }}</span>
              <span class="stat-label">有效推广</span>
            </div>
            <van-tag v-if="top3[0].qualified" color="#07c160" round size="medium" class="podium-tag">已达标</van-tag>
            <van-tag v-else plain color="#ff976a" round size="medium" class="podium-tag">未达标</van-tag>
          </div>
          <div class="podium-base gold-base">
            <span class="base-rank">1</span>
          </div>
        </div>
        <!-- 第三名（右） -->
        <div class="podium-col third podium-enter" style="animation-delay: 0.5s" v-if="top3[2]">
          <div class="podium-card">
            <div class="podium-badge">
              <span class="badge-icon badge-bounce" style="animation-delay: 1.0s">&#129353;</span>
            </div>
            <div class="podium-ring bronze-ring">
              <van-image v-if="top3[2].avatarUrl" round width="100%" height="100%" fit="cover" :src="top3[2].avatarUrl" />
              <div v-else class="avatar-fallback">{{ top3[2].promoterName.charAt(0) }}</div>
            </div>
            <div class="podium-name">{{ top3[2].promoterName }}</div>
            <div class="podium-stats">
              <span class="stat-num stat-pop" style="animation-delay: 1.2s">{{ top3[2].validPromotionCount }}</span>
              <span class="stat-label">有效推广</span>
            </div>
            <van-tag v-if="top3[2].qualified" color="#07c160" round size="medium" class="podium-tag">已达标</van-tag>
            <van-tag v-else plain color="#ff976a" round size="medium" class="podium-tag">未达标</van-tag>
          </div>
          <div class="podium-base bronze-base">
            <span class="base-rank">3</span>
          </div>
        </div>
      </div>

      <!-- 排名列表 -->
      <div class="rank-list">
        <div class="list-title">
          <span class="list-title-text">排名详情</span>
          <span class="list-title-count">Top {{ displayList.length }}</span>
        </div>
        <div class="list-header">
          <span class="col-rank">排名</span>
          <span class="col-name">参赛者</span>
          <span class="col-valid">有效推广</span>
          <span class="col-total">推广总数</span>
          <span class="col-status">状态</span>
        </div>
        <div
          v-for="(item, index) in restList"
          :key="item.promoterId"
          class="list-row"
          :class="{
            'is-prize': index < 7,
            'is-normal': index >= 7
          }"
        >
          <span class="col-rank">
            <span class="rank-num" :class="{ 'rank-prize': index < 7 }">{{ index + 4 }}</span>
          </span>
          <div class="col-name">
            <van-image
              v-if="item.avatarUrl"
              round
              width="28"
              height="28"
              fit="cover"
              class="row-avatar"
              :src="item.avatarUrl"
            />
            <div v-else class="row-avatar-fallback">{{ item.promoterName.charAt(0) }}</div>
            <span class="row-name">{{ item.promoterName }}</span>
          </div>
          <span class="col-valid">{{ item.validPromotionCount }}</span>
          <span class="col-total">{{ item.totalPromotedMembers }}</span>
          <span class="col-status">
            <van-tag v-if="item.qualified" color="#07c160" round size="medium">已达标</van-tag>
            <van-tag v-else plain color="#ff976a" round size="medium">未达标</van-tag>
          </span>
        </div>
      </div>
    </div>

    <!-- 活动规则弹窗 -->
    <van-popup v-model="showRule" position="bottom" round class="rank-rule-popup" :style="{ maxHeight: '80%', marginBottom: '12vh' }">
      <div class="rule-popup">
        <div class="rule-header">
          <div class="rule-title">活动说明</div>
          <van-icon name="cross" class="rule-close" @click="showRule = false" />
        </div>
        <div class="rule-divider"></div>

        <!-- 活动时间 -->
        <div class="rule-section">
          <div class="section-title">活动时间</div>
          <div class="section-body">2026年9月1日 — 2026年10月31日 24时</div>
        </div>

        <!-- 如何邀请推广 -->
        <div class="rule-section">
          <div class="section-title">如何邀请推广</div>
          <div class="step-list">
            <div class="step-item">
              <span class="step-num">1</span>
              <div class="step-text">
                <span class="step-title">下载并打开搜机网APP</span>
                <span class="step-desc">各大应用市场搜索"搜机网"即可下载</span>
              </div>
            </div>
            <div class="step-arrow"><van-icon name="arrow-down" size="14" color="#ddd" /></div>
            <div class="step-item">
              <span class="step-num">2</span>
              <div class="step-text">
                <span class="step-title">登录账号</span>
                <span class="step-desc">使用您的手机号或账号密码登录</span>
              </div>
            </div>
            <div class="step-arrow"><van-icon name="arrow-down" size="14" color="#ddd" /></div>
            <div class="step-item">
              <span class="step-num">3</span>
              <div class="step-text">
                <span class="step-title">进入"我的" → "推荐客户"</span>
                <span class="step-desc">在底部导航栏点击"我的"，找到推荐客户入口</span>
              </div>
            </div>
            <div class="step-arrow"><van-icon name="arrow-down" size="14" color="#ddd" /></div>
            <div class="step-item">
              <span class="step-num">4</span>
              <div class="step-text">
                <span class="step-title">点击"邀请分享"按钮</span>
                <span class="step-desc">将专属邀请链接或海报分享给好友</span>
              </div>
            </div>
          </div>
          <div class="guide-gif-btn" @click="showGif = true">
            <van-icon name="video-o" size="16" />
            <span>查看操作演示</span>
          </div>
        </div>

        <!-- 搜机网会员权益 -->
        <div class="rule-section">
          <div class="section-title">搜机网会员权益</div>
          <div class="benefit-list">
            <div class="benefit-item">
              <span class="benefit-icon">&#128172;</span>
              <div class="benefit-text">
                <span class="benefit-name">供求大厅使用资格</span>
                <span class="benefit-desc">送一个10万+人的行业"大群"，海量供需信息实时对接</span>
              </div>
            </div>
            <div class="benefit-item">
              <span class="benefit-icon">&#128200;</span>
              <div class="benefit-text">
                <span class="benefit-name">免费大盘行情</span>
                <span class="benefit-desc">实时掌握出货/收货行情走势，精准把握市场脉搏</span>
              </div>
            </div>
            <div class="benefit-item">
              <span class="benefit-icon">&#128269;</span>
              <div class="benefit-text">
                <span class="benefit-name">验机查询优惠</span>
                <span class="benefit-desc">会员专享验机查询折扣，降低交易风险</span>
              </div>
            </div>
            <div class="benefit-item">
              <span class="benefit-icon">&#128222;</span>
              <div class="benefit-text">
                <span class="benefit-name">全国同行联系方式</span>
                <span class="benefit-desc">发报价，查看全国300城市手机数码同行联系方式</span>
              </div>
            </div>
            <div class="benefit-item">
              <span class="benefit-icon">&#128176;</span>
              <div class="benefit-text">
                <span class="benefit-name">在线钱包 & 担保交易</span>
                <span class="benefit-desc">防冻卡、防限额；在线交易担保，0手续费</span>
              </div>
            </div>
          </div>
        </div>

        <!-- 一、参赛资格 -->
        <div class="rule-section">
          <div class="section-title">一、参赛资格</div>
          <div class="rule-content">
            <div class="rule-item">
              <span class="rule-dot"></span>
              <span>仅限平台有效期内会员和试用会员参与；会员费有折扣（国产手机/网页版充值打<em class="rule-highlight">8折</em>）。</span>
            </div>
            <div class="rule-item">
              <span class="rule-dot"></span>
              <span>参赛者有效付费直推新会员满<em class="rule-highlight">80人</em>，即可参与榜单排名、角逐实物奖品；未满80人无排名获奖资格。</span>
            </div>
            <div class="rule-item">
              <span class="rule-dot"></span>
              <span>分部员工及渠道参与需提前报备，搜机网拥有参赛资格最终审核权。</span>
            </div>
          </div>
        </div>

        <!-- 二、有效推广判定 -->
        <div class="rule-section">
          <div class="section-title">二、有效推广判定</div>
          <div class="rule-content">
            <div class="rule-item">
              <span class="rule-dot"></span>
              <span>仅统计参赛者直推、完成实名认证且成功付费的<em class="rule-highlight">新增会员数据</em>。</span>
            </div>
            <div class="rule-item">
              <span class="rule-dot"></span>
              <span>有效会员认定：被推广人首次注册账号、完成实名并开通会员，且开通后<em class="rule-highlight">连续30天无退费</em>，期满复核后计入有效业绩。</span>
            </div>
          </div>
        </div>

        <!-- 三、排名与奖励规则 -->
        <div class="rule-section">
          <div class="section-title">三、排名与奖励规则</div>
          <div class="rule-content">
            <div class="rule-item">
              <span class="rule-dot"></span>
              <span>活动结束复核完毕后，按有效付费会员推广数量从高到低排名；数量相同则以<em class="rule-highlight">率先达标时间</em>先后排序。</span>
            </div>
            <div class="rule-item">
              <span class="rule-dot"></span>
              <span>直推未满80人的参与者，也可获得被推广会员充值金额<em class="rule-highlight">10%</em>的现金奖励，自动发放至账号，支持提现。<em class="rule-highlight">（人人有奖）</em></span>
            </div>
          </div>
          <div class="prize-list" style="margin-top: 12px;">
            <div class="prize-row prize-gold">
              <span class="prize-rank">一等奖</span>
              <span class="prize-name">iPhone 18 Pro Max 256G</span>
            </div>
            <div class="prize-row prize-silver">
              <span class="prize-rank">二等奖</span>
              <span class="prize-name">iPhone 18 Pro 256G</span>
            </div>
            <div class="prize-row prize-bronze">
              <span class="prize-rank">三等奖</span>
              <span class="prize-name">iPhone 17 256G</span>
            </div>
            <div class="prize-row">
              <span class="prize-rank">四等奖</span>
              <span class="prize-name">Mate 80 Pro 256G</span>
            </div>
            <div class="prize-row">
              <span class="prize-rank">五等奖</span>
              <span class="prize-name">iPhone 17e 256G</span>
            </div>
            <div class="prize-row">
              <span class="prize-rank">六等奖</span>
              <span class="prize-name">iPad 11寸（2025款）256G</span>
            </div>
            <div class="prize-row">
              <span class="prize-rank">七等奖</span>
              <span class="prize-name">iPhone S11 42mm</span>
            </div>
            <div class="prize-row">
              <span class="prize-rank">八等奖</span>
              <span class="prize-name">华为畅享 90 Pro MAX 512G</span>
            </div>
            <div class="prize-row">
              <span class="prize-rank">九等奖</span>
              <span class="prize-name">苹果耳机 P93</span>
            </div>
            <div class="prize-row">
              <span class="prize-rank">十等奖</span>
              <span class="prize-name">苹果耳机 P63</span>
            </div>
          </div>
        </div>

        <!-- 四、活动须知 -->
        <div class="rule-section">
          <div class="section-title">四、活动须知</div>
          <div class="rule-content">
            <div class="rule-item">
              <span class="rule-dot"></span>
              <span>参与本次活动，即默认知晓并同意本次全部活动规则。</span>
            </div>
            <div class="rule-item">
              <span class="rule-dot"></span>
              <span>所有奖品均为实物，<em class="rule-highlight">不折现、不置换、不更换</em>其他礼品。</span>
            </div>
            <div class="rule-item">
              <span class="rule-dot"></span>
              <span>在法律允许范围内，主办方搜机网拥有本次活动的最终解释权。</span>
            </div>
          </div>
        </div>

        <van-button type="danger" block round class="rule-btn" @click="showRule = false">我知道了</van-button>
      </div>
    </van-popup>

    <!-- 操作演示全屏弹窗 -->
    <van-popup v-model="showGif" class="gif-fullscreen-popup">
      <div class="gif-fullscreen" @click="showGif = false">
        <div class="gif-close">
          <van-icon name="cross" size="20" color="#fff" />
        </div>
        <div class="video-container">
          <video
            ref="guideVideo"
            class="gif-fullscreen-img"
            src="/guide-promotion.mp4"
            loop
            muted
            playsinline
            webkit-playsinline
            x5-video-player-type="h5"
            x5-video-player-fullscreen="false"
            x5-video-orientation="portraint"
            @click.stop
          />
          <div class="video-play-btn" @click.stop="playVideo">
            <van-icon name="play-circle-o" size="48" color="#fff" />
          </div>
        </div>
        <div class="gif-fullscreen-tip">点击任意处关闭</div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { getPromotionRankTop100 } from '@/api/promotionRank'

export default {
  name: 'PromotionRank',
  data () {
    return {
      rankList: [],
      loading: true,
      showRule: false,
      showGif: false
    }
  },
  computed: {
    displayList () {
      return this.rankList.slice(0, 20)
    },
    top3 () {
      return this.displayList.slice(0, 3)
    },
    restList () {
      return this.displayList.slice(3)
    }
  },
  mounted () {
    this.fetchData()
  },
  watch: {
    showGif (val) {
      if (val) {
        this.$nextTick(() => {
          this.playVideo()
        })
      } else {
        const video = this.$refs.guideVideo
        if (video) {
          video.pause()
          video.currentTime = 0
        }
      }
    }
  },
  methods: {
    playVideo () {
      const video = this.$refs.guideVideo
      if (video) {
        video.play().catch(() => {})
      }
    },
    async fetchData () {
      this.loading = true
      try {
        const res = await getPromotionRankTop100()
        if (res.code === 1) {
          this.rankList = res.data || []
        } else {
          this.$toast(res.errMsg || '获取排名失败')
        }
      } catch (e) {
        console.error('获取推广排名失败', e)
        this.$toast('网络异常，请稍后重试')
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped lang="scss">
.promotion-rank {
  min-height: 100vh;
  background: #f7f8fa;
  padding-bottom: calc(24px + env(safe-area-inset-bottom));
}

/* ========== 顶部横幅 ========== */
.header-banner {
  background: linear-gradient(160deg, #ff4e2c 0%, #ee0a24 40%, #c8102e 100%);
  padding: 32px 20px 44px;
  text-align: center;
  color: #fff;
  position: relative;
  overflow: hidden;

  .banner-decor {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    pointer-events: none;
  }

  .dot {
    position: absolute;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.12);
  }
  .dot-1 { width: 120px; height: 120px; top: -40px; right: -30px; }
  .dot-2 { width: 80px; height: 80px; bottom: -20px; left: -20px; }
  .dot-3 { width: 50px; height: 50px; top: 30px; left: 20%; background: rgba(255, 255, 255, 0.08); }

  .star {
    position: absolute;
    color: rgba(255, 255, 255, 0.2);
    font-size: 16px;
  }
  .star-1 { top: 18px; right: 60px; font-size: 12px; }
  .star-2 { top: 50px; left: 30px; font-size: 10px; }
  .star-3 { bottom: 30px; right: 25%; font-size: 14px; }

  .banner-crown {
    font-size: 36px;
    margin-bottom: 4px;
    filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.2));
  }

  .banner-title {
    font-size: 22px;
    font-weight: 800;
    letter-spacing: 3px;
    text-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  }

  .banner-subtitle {
    font-size: 14px;
    margin-top: 6px;
    opacity: 0.85;
    letter-spacing: 6px;
    font-weight: 300;
  }

  .banner-rule {
    position: absolute;
    right: 12px;
    top: 12px;
    font-size: 11px;
    background: rgba(255, 255, 255, 0.2);
    backdrop-filter: blur(4px);
    padding: 4px 10px;
    border-radius: 20px;
    display: flex;
    align-items: center;
    gap: 3px;
    cursor: pointer;
    transition: background 0.2s;

    &:active {
      background: rgba(255, 255, 255, 0.35);
    }
  }
}

/* ========== 加载状态 ========== */
.loading-wrap {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 100px 0;

  .loading-text {
    margin-top: 16px;
    font-size: 13px;
    color: #999;
  }
}

/* ========== 前三名领奖台 ========== */
.top3-podium {
  display: flex;
  justify-content: center;
  align-items: flex-end;
  padding: 0 10px;
  margin-top: -36px;
  position: relative;
  z-index: 1;

  .podium-col {
    display: flex;
    flex-direction: column;
    align-items: center;
    flex: 1;
    max-width: 130px;
    position: relative;

    &.first { order: 2; }
    &.second { order: 1; margin-right: -6px; position: relative; z-index: 1; }
    &.third { order: 3; margin-left: -6px; position: relative; z-index: 1; }
  }

  /* 人物卡片 */
  .podium-card {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    background: #fff;
    border-radius: 14px 14px 0 0;
    padding: 16px 6px 12px;
    box-shadow: 0 -2px 16px rgba(0, 0, 0, 0.06);
    position: relative;

    .first & {
      padding: 20px 6px 16px;
      background: linear-gradient(180deg, #fffbf0 0%, #fff 50%);
      border-radius: 16px 16px 0 0;
    }
    .second & {
      background: linear-gradient(180deg, #f4f6fa 0%, #fff 50%);
    }
    .third & {
      background: linear-gradient(180deg, #fdf6f0 0%, #fff 50%);
    }
  }

  /* 奖牌徽章 */
  .podium-badge {
    position: absolute;
    top: -4px;
    right: 2px;

    .badge-icon {
      font-size: 20px;
      filter: drop-shadow(0 1px 3px rgba(0, 0, 0, 0.15));
    }

    .first & {
      top: -6px;
      right: 4px;

      .badge-icon { font-size: 24px; }
    }
  }

  /* 头像环 */
  .podium-ring {
    width: 50px;
    height: 50px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 3px;
    overflow: hidden;

    &.gold-ring {
      width: 62px;
      height: 62px;
      background: linear-gradient(135deg, #ffd700, #f0a000);
      box-shadow: 0 3px 14px rgba(255, 180, 0, 0.4);
    }
    &.silver-ring {
      background: linear-gradient(135deg, #d4d4d4, #a8a8a8);
      box-shadow: 0 3px 10px rgba(160, 160, 160, 0.3);
    }
    &.bronze-ring {
      background: linear-gradient(135deg, #d4956a, #a0693c);
      box-shadow: 0 3px 10px rgba(180, 120, 60, 0.3);
    }
  }

  .avatar-fallback {
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background: linear-gradient(135deg, #667eea, #764ba2);
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    font-size: 18px;
    font-weight: 700;
  }

  .podium-name {
    margin-top: 8px;
    font-size: 12px;
    color: #333;
    font-weight: 600;
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    text-align: center;

    .first & {
      font-size: 13px;
      margin-top: 10px;
    }
  }

  .podium-stats {
    margin-top: 4px;
    display: flex;
    flex-direction: column;
    align-items: center;

    .stat-num {
      font-size: 18px;
      font-weight: 800;
      color: #ee0a24;
      line-height: 1.2;

      .first & { font-size: 22px; }
    }
    .stat-label {
      font-size: 10px;
      color: #999;
      margin-top: 2px;
    }
  }

  .podium-tag {
    margin-top: 6px;
  }

  /* ========== 领奖台底座 ========== */
  .podium-base {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 0 0 10px 10px;
    position: relative;
    overflow: hidden;

    .base-rank {
      font-size: 28px;
      font-weight: 900;
      color: rgba(255, 255, 255, 0.6);
      line-height: 1;
    }

    &.gold-base {
      height: 72px;
      background: linear-gradient(180deg, #ffd700 0%, #e6a800 100%);
      box-shadow: 0 4px 16px rgba(255, 180, 0, 0.3);

      .base-rank {
        font-size: 34px;
        color: rgba(255, 255, 255, 0.7);
        text-shadow: 0 2px 4px rgba(180, 120, 0, 0.3);
      }

      &::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        height: 3px;
        background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.5), transparent);
      }
    }

    &.silver-base {
      height: 52px;
      background: linear-gradient(180deg, #c0c0c0 0%, #a0a0a0 100%);
      box-shadow: 0 4px 12px rgba(160, 160, 160, 0.25);

      &::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        height: 2px;
        background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.4), transparent);
      }
    }

    &.bronze-base {
      height: 38px;
      background: linear-gradient(180deg, #cd7f32 0%, #a0622a 100%);
      box-shadow: 0 4px 12px rgba(180, 120, 60, 0.25);

      &::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        height: 2px;
        background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.35), transparent);
      }
    }
  }

  /* 冠军闪光装饰 */
  .sparkles {
    position: absolute;
    top: -8px;
    left: 0;
    right: 0;
    height: 40px;
    pointer-events: none;
    z-index: 2;

    .sparkle {
      position: absolute;
      color: #ffd700;
      font-size: 12px;
      animation: sparkleFloat 2s ease-in-out infinite;

      &.s1 { left: 15%; top: 5px; animation-delay: 0s; font-size: 10px; }
      &.s2 { right: 18%; top: 0; animation-delay: 0.7s; font-size: 14px; }
      &.s3 { left: 50%; top: -5px; animation-delay: 1.3s; font-size: 8px; }
    }
  }
}

/* ========== 排名列表 ========== */
.rank-list {
  margin: 20px 12px;
  background: #fff;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 2px 16px rgba(0, 0, 0, 0.05);

  .list-title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 14px 16px 10px;

    .list-title-text {
      font-size: 15px;
      font-weight: 700;
      color: #333;
    }
    .list-title-count {
      font-size: 11px;
      color: #999;
      background: #f5f5f5;
      padding: 2px 8px;
      border-radius: 10px;
    }
  }

  .list-header {
    display: flex;
    align-items: center;
    padding: 10px 16px;
    font-size: 11px;
    color: #bbb;
    border-bottom: 1px solid #f5f5f5;

    .col-rank { width: 36px; text-align: center; }
    .col-name { flex: 1; padding-left: 4px; }
    .col-valid { width: 60px; text-align: center; }
    .col-total { width: 60px; text-align: center; }
    .col-status { width: 60px; text-align: center; }
  }

  .list-row {
    display: flex;
    align-items: center;
    padding: 10px 16px;
    border-bottom: 1px solid #f8f8f8;
    font-size: 13px;
    color: #333;
    transition: background 0.15s;

    &:last-child {
      border-bottom: none;
    }

    &:active {
      background: #f9f9f9;
    }

    /* 4-10名：有奖区间高亮 */
    &.is-prize {
      background: #fffbf5;
    }

    /* 11名以后：弱化 */
    &.is-normal {
      opacity: 0.6;
    }

    .col-rank {
      width: 36px;
      text-align: center;

      .rank-num {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        min-width: 22px;
        height: 22px;
        border-radius: 6px;
        background: #f0f1f3;
        font-size: 12px;
        font-weight: 700;
        color: #888;
        padding: 0 4px;

        &.rank-prize {
          background: #fff0e0;
          color: #e8752a;
        }
      }
    }

    .col-name {
      flex: 1;
      padding-left: 4px;
      display: flex;
      align-items: center;
      gap: 8px;
      overflow: hidden;

      .row-avatar {
        flex-shrink: 0;
      }

      .row-avatar-fallback {
        flex-shrink: 0;
        width: 28px;
        height: 28px;
        border-radius: 50%;
        background: linear-gradient(135deg, #667eea, #764ba2);
        display: flex;
        align-items: center;
        justify-content: center;
        color: #fff;
        font-size: 13px;
        font-weight: 600;
      }

      .row-name {
        font-weight: 500;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }

    .col-valid {
      width: 60px;
      text-align: center;
      font-weight: 700;
      color: #ee0a24;
    }

    .col-total {
      width: 60px;
      text-align: center;
      color: #666;
    }

    .col-status {
      width: 60px;
      text-align: center;
    }
  }
}

/* ========== 活动规则弹窗 ========== */
.rule-popup {
  padding: 20px 20px 24px;

  .rule-header {
    display: flex;
    align-items: center;
    justify-content: space-between;

    .rule-title {
      font-size: 17px;
      font-weight: 700;
      color: #333;
    }
    .rule-close {
      font-size: 18px;
      color: #999;
      cursor: pointer;
      padding: 4px;
    }
  }

  .rule-divider {
    height: 1px;
    background: linear-gradient(90deg, transparent, #eee, transparent);
    margin: 14px 0;
  }

  .rule-section {
    margin-bottom: 18px;

    .section-title {
      font-size: 14px;
      font-weight: 700;
      color: #333;
      margin-bottom: 10px;
      padding-left: 10px;
      border-left: 3px solid #ee0a24;
    }

    .section-body {
      font-size: 13px;
      color: #555;
      line-height: 1.7;
      padding-left: 13px;
    }
  }

  .prize-list {
    background: #fafafa;
    border-radius: 10px;
    padding: 4px 0;

    .prize-row {
      display: flex;
      align-items: center;
      padding: 9px 14px;
      font-size: 13px;
      border-bottom: 1px solid #f0f0f0;

      &:last-child {
        border-bottom: none;
      }

      .prize-rank {
        width: 52px;
        flex-shrink: 0;
        font-weight: 600;
        color: #666;
      }

      .prize-name {
        flex: 1;
        color: #333;
      }

      &.prize-gold {
        background: linear-gradient(90deg, #fff8e6, #fafafa 60%);

        .prize-rank { color: #d4a017; }
        .prize-name { color: #b8860b; font-weight: 700; }
      }

      &.prize-silver {
        background: linear-gradient(90deg, #f5f5f8, #fafafa 60%);

        .prize-rank { color: #8a8a8a; }
        .prize-name { color: #666; font-weight: 600; }
      }

      &.prize-bronze {
        background: linear-gradient(90deg, #fdf5ee, #fafafa 60%);

        .prize-rank { color: #b87333; }
        .prize-name { color: #8b5e3c; font-weight: 600; }
      }
    }
  }

  .step-list {
    .step-item {
      display: flex;
      align-items: flex-start;
      gap: 12px;
      padding: 8px 12px;
      background: #fafafa;
      border-radius: 10px;
    }

    .step-num {
      flex-shrink: 0;
      width: 24px;
      height: 24px;
      border-radius: 50%;
      background: linear-gradient(135deg, #ff6034, #ee0a24);
      color: #fff;
      font-size: 13px;
      font-weight: 700;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: 1px;
    }

    .step-text {
      flex: 1;
      display: flex;
      flex-direction: column;
      gap: 2px;
    }

    .step-title {
      font-size: 13px;
      font-weight: 600;
      color: #333;
    }

    .step-desc {
      font-size: 11px;
      color: #999;
    }

    .step-arrow {
      display: flex;
      justify-content: center;
      padding: 4px 0;
    }

    .guide-gif-btn {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 6px;
      margin: 14px auto 0;
      padding: 8px 20px;
      background: linear-gradient(135deg, #ff6034, #ee0a24);
      color: #fff;
      font-size: 13px;
      font-weight: 600;
      border-radius: 20px;
      cursor: pointer;
      box-shadow: 0 3px 12px rgba(238, 10, 36, 0.3);
      transition: transform 0.15s, box-shadow 0.15s;

      &:active {
        transform: scale(0.96);
        box-shadow: 0 2px 8px rgba(238, 10, 36, 0.25);
      }
    }
  }

  .rule-content {
    .rule-item {
      display: flex;
      align-items: flex-start;
      gap: 10px;
      margin-bottom: 12px;
      font-size: 13px;
      color: #555;
      line-height: 1.7;

      .rule-dot {
        flex-shrink: 0;
        width: 6px;
        height: 6px;
        border-radius: 50%;
        background: #ee0a24;
        margin-top: 8px;
      }

      .rule-highlight {
        color: #ee0a24;
        font-weight: 700;
        font-style: normal;
        background: linear-gradient(180deg, transparent 60%, rgba(238, 10, 36, 0.12) 60%);
        padding: 0 2px;
      }
    }
  }

  .benefit-list {
    background: linear-gradient(135deg, #fff8f0 0%, #fff 100%);
    border-radius: 12px;
    padding: 6px 0;
    border: 1px solid #ffe8d6;

    .benefit-item {
      display: flex;
      align-items: flex-start;
      gap: 12px;
      padding: 11px 14px;
      border-bottom: 1px solid #fff0e0;
      transition: background 0.15s;

      &:last-child {
        border-bottom: none;
      }

      &:active {
        background: rgba(255, 150, 50, 0.05);
      }
    }

    .benefit-icon {
      flex-shrink: 0;
      width: 32px;
      height: 32px;
      border-radius: 8px;
      background: linear-gradient(135deg, #ff8c42, #ff6034);
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 16px;
      box-shadow: 0 2px 8px rgba(255, 96, 52, 0.2);
    }

    .benefit-text {
      flex: 1;
      display: flex;
      flex-direction: column;
      gap: 2px;
      min-width: 0;
    }

    .benefit-name {
      font-size: 13px;
      font-weight: 700;
      color: #333;
      line-height: 1.4;
    }

    .benefit-desc {
      font-size: 11px;
      color: #888;
      line-height: 1.5;
    }
  }

  .rule-btn {
    font-weight: 600;
    margin-top: 4px;
  }
}

/* ========== 动画特效 ========== */

/* 列入场：从下方滑入 + 渐显 */
@keyframes slideUp {
  0% {
    opacity: 0;
    transform: translateY(50px) scale(0.95);
  }
  60% {
    opacity: 1;
    transform: translateY(-4px) scale(1.01);
  }
  100% {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

.podium-enter {
  opacity: 0;
  animation: slideUp 0.6s cubic-bezier(0.34, 1.56, 0.64, 1) forwards;
}

/* 皇冠弹跳 */
@keyframes crownBounce {
  0%, 100% { transform: translateY(0); }
  20% { transform: translateY(-8px); }
  40% { transform: translateY(0); }
  60% { transform: translateY(-4px); }
  80% { transform: translateY(0); }
}

.crown-bounce {
  animation: crownBounce 2s ease-in-out infinite;
  animation-delay: 1.2s;
}

/* 奖牌徽章弹入 */
@keyframes badgeBounceIn {
  0% {
    opacity: 0;
    transform: scale(0.3) rotate(-15deg);
  }
  50% {
    transform: scale(1.15) rotate(5deg);
  }
  70% {
    transform: scale(0.95) rotate(-2deg);
  }
  100% {
    opacity: 1;
    transform: scale(1) rotate(0deg);
  }
}

.badge-bounce {
  opacity: 0;
  animation: badgeBounceIn 0.5s cubic-bezier(0.34, 1.56, 0.64, 1) forwards;
}

/* 数字弹出 */
@keyframes statPop {
  0% {
    opacity: 0;
    transform: scale(0.5);
  }
  60% {
    transform: scale(1.2);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
}

.stat-pop {
  opacity: 0;
  animation: statPop 0.4s cubic-bezier(0.34, 1.56, 0.64, 1) forwards;
}

/* 冠军金色底座光晕脉冲 */
@keyframes goldGlow {
  0%, 100% {
    box-shadow: 0 4px 16px rgba(255, 180, 0, 0.3);
  }
  50% {
    box-shadow: 0 4px 28px rgba(255, 180, 0, 0.55), 0 0 20px rgba(255, 215, 0, 0.25);
  }
}

.gold-base {
  animation: goldGlow 3s ease-in-out 1.5s infinite;
}

/* 闪光漂浮 */
@keyframes sparkleFloat {
  0%, 100% {
    opacity: 0;
    transform: translateY(0) scale(0.5);
  }
  50% {
    opacity: 1;
    transform: translateY(-8px) scale(1);
  }
}

/* ========== 操作演示全屏弹窗 ========== */
::v-deep .gif-fullscreen-popup {
  background: transparent !important;
}

.gif-fullscreen {
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.92);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 24px 60px;
  box-sizing: border-box;
  position: relative;

  .gif-close {
    position: absolute;
    top: 16px;
    right: 16px;
    width: 36px;
    height: 36px;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.15);
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    z-index: 2;
  }

  .gif-fullscreen-img {
    max-width: 100%;
    max-height: 70vh;
    border-radius: 12px;
    box-shadow: 0 8px 40px rgba(0, 0, 0, 0.5);
    display: block;
  }

  .video-container {
    position: relative;
    display: inline-block;
  }

  .video-play-btn {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 64px;
    height: 64px;
    border-radius: 50%;
    background: rgba(0, 0, 0, 0.4);
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: opacity 0.3s;
    z-index: 2;
  }

  .gif-fullscreen-tip {
    margin-top: 16px;
    font-size: 12px;
    color: rgba(255, 255, 255, 0.4);
  }
}

/* ========== PC端兼容（≥750px）：居中限宽 + 头像放大 ========== */
@media screen and (min-width: 750px) {
  .promotion-rank {
    /* App.vue 的 .appView scoped 样式会把这个路由根设为 position:absolute; left:0，
       导致 margin:auto 无法居中。PC 端改回 relative，走标准块级居中。 */
    position: relative !important;
    left: auto !important;
    right: auto !important;
    width: 100% !important;
    max-width: 480px;
    margin: 0 auto;
    min-height: 100vh;
    box-shadow: 0 0 24px rgba(0, 0, 0, 0.1);
    background-color: #f7f8fa;
    background-image: linear-gradient(180deg, #ebebed 0%, #f7f8fa 220px);
  }

  /* 前三名领奖台头像放大 */
  .top3-podium .podium-ring.gold-ring { width: 76px; height: 76px; }
  .top3-podium .podium-ring.silver-ring,
  .top3-podium .podium-ring.bronze-ring { width: 64px; height: 64px; }
  .top3-podium .avatar-fallback { font-size: 26px; }
  .top3-podium .podium-name { font-size: 14px; }
  .top3-podium .podium-stats .stat-num { font-size: 22px; }
  .top3-podium .first .podium-stats .stat-num { font-size: 26px; }

  /* 排名列表头像放大 */
  .rank-list .row-avatar-fallback { width: 40px; height: 40px; font-size: 16px; }
  .rank-list .row-avatar { width: 40px !important; height: 40px !important; }
  .rank-list .list-row { padding: 12px 16px; font-size: 14px; }
}
</style>

<style>
/* PC端弹窗随页面居中限宽（不影响移动端） */
@media screen and (min-width: 750px) {
  .rank-rule-popup.van-popup {
    width: 480px !important;
    max-width: 100% !important;
    left: 50% !important;
    right: auto !important;
    margin-left: -240px !important;
  }
}
</style>
